import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxWebstorageModule } from 'ngx-webstorage';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';

@NgModule({
  // module import order matters for NgModules
  imports: [
    BrowserModule,
    CoreModule,
    NgxWebstorageModule.forRoot(),
    AppRoutingModule, // routing modules must always be imported last
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
